exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-center[data-v-e3da88fa]{text-align:center}.day-month-year-picker p[data-v-e3da88fa]{font-size:12px;padding:8px 12px;padding-bottom:0}.day-month-year-picker select[data-v-e3da88fa]{height:35px;padding:8px 12px;padding-right:0!important;padding-top:0}.is-full-width.pr-5[data-v-e3da88fa]{padding-right:25px}.mb-2[data-v-e3da88fa]{margin-bottom:20px}.is-required[data-v-e3da88fa]{padding-left:0}.province[data-v-e3da88fa]{padding:8px;font-size:12px;margin-bottom:0;padding-bottom:0}select.province-select[data-v-e3da88fa]{position:relative;top:-5px}", ""]);

// exports
